module.exports = __webpack_public_path__ + "static/media/icRemittanceNext.5587961c.svg";